import React from "react";
import { init } from "ityped";
import "./Intro.scss";
import { useEffect, useRef } from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
// import Link from "@material-ui/core/Link";

function Intro() {
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      backDelay: 1500,
      backSpeed: 60,
      showCursor: true,
      strings: [
        "BackEnd Developer",
        "FrontEnd Developer",
        "FullStack Developer",
      ],
    });
  }, []);
  return (
    <div className="intro" id="intro">
      <div className="left">
        <div className="imageContainer">
          <img
            src="assets/avinash2.png"
            alt=""
            style={{ height: "100%", width: "70%" }}
          />
        </div>
      </div>
      <div className="right">
        <div className="wrapper">
          <h2>Hi There, I'm</h2>
          <h1>Avinash Dhanani</h1>
          <h3>Freelancer</h3>
          <h3>
            <span ref={textRef}></span>
          </h3>
          <div className="icons">
            <a
              href="https://github.com/avinashDhanani"
              className="link"
              target="_blank"
            >
              <GitHubIcon className="icon" />
            </a>
            <a
              href="https://www.linkedin.com/in/avinash-dhanani-13098b1a1/"
              className="link"
              target="_blank"
            >
              <LinkedInIcon className="icon" />
            </a>
            <a
              href="mailto:avinashdhanani1@gmail.com"
              className="link"
              target="_blank"
            >
              <EmailIcon className="icon" />
            </a>
            <a
              href="https://www.instagram.com/avinash.dhanani/"
              className="link"
              target="_blank"
            >
              <InstagramIcon className="icon" />
            </a>
          </div>
        </div>
        <a href="#portfolio" className="downarro">
          <img src="assets/down.png" alt="" />
        </a>
      </div>
    </div>
  );
}

export default Intro;
